<template>
  <div>
    <section class="">
      <div class="container">
        <div class="main">
          <!-- 新增內容 ↓ -->
          <div class="bg-box" v-if="MemberCouponMainData">
            <h1>{{ }}</h1>
            <hr>
            <div class="img_box">
              <img v-if="MemberCouponMainData.CouponList.Coupon.Image"
                :src="MemberCouponMainData.SiteUrl + MemberCouponMainData.CouponList.Coupon.Image" alt=""></img>
              <img v-else src="img/coupon_logo.svg" alt="">
            </div>
            <p v-if="!MemberCouponMainData.CouponList.Coupon.StartTime && !MemberCouponMainData.CouponList.Coupon.EndTime"
              class="time">無使用期限</p>
            <p v-if="MemberCouponMainData.CouponList.Coupon.StartTime && !MemberCouponMainData.CouponList.Coupon.EndTime"
              class="time">使用期限：<span>{{
                timeString(MemberCouponMainData.CouponList.Coupon.StartTime, "YYYY/MM/DD HH:mm") }} 起</span></p>
            <p v-if="!MemberCouponMainData.CouponList.Coupon.StartTime && MemberCouponMainData.CouponList.Coupon.EndTime"
              class="time">使用期限：<span>{{
                timeString(MemberCouponMainData.CouponList.Coupon.EndTime, "YYYY/MM/DD HH:mm") }} 截止</span></p>
            <p v-if="MemberCouponMainData.CouponList.Coupon.StartTime && MemberCouponMainData.CouponList.Coupon.EndTime"
              class="time">使用期限：<span>{{
                timeString(MemberCouponMainData.CouponList.Coupon.StartTime, "YYYY/MM/DD HH:mm") }} 到 {{
                  timeString(MemberCouponMainData.CouponList.Coupon.EndTime, "YYYY/MM/DD HH:mm") }}</span></p>
            <p class="time">可使用次數: <span>{{ MemberCouponMainData.CouponList.Time }}</span></p>
            <div class="text_notice" v-if="MemberCouponMainData.CouponList.Coupon.UseNote">
              <h2>注意事項</h2>
              <template
                v-if="MemberCouponMainData && MemberCouponMainData.CouponList && MemberCouponMainData.CouponList.Coupon.UseNote">
                <p v-for="(line, index) in MemberCouponMainData.CouponList.Coupon.UseNote.split('\n')" :key="index">
                  {{ line }}
                </p>
              </template>
            </div>
            <div class="btn_box">
              <button class="btn_coupon_use" type="button" data-toggle="modal"
                data-target="#couponUseModal">立即使用</button>
              <router-link :to="{ name: 'MemberCoupon' }" class="btn_coupon_use" tag="button">
                返回列表
              </router-link>
            </div>
          </div>
          <!-- 新增內容 ↑ -->
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
    <!-- Modal -->
    <div class="modal fade" id="couponUseModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="title">
              <h2>提醒</h2>
              <button type="button" class="cancel_btn" data-dismiss="modal">X</button>
            </div>
            <img src="img/coupon_img.svg" alt="">
            <template
              v-if="MemberCouponMainData && MemberCouponMainData.CouponList && MemberCouponMainData.CouponList.Coupon.ConfirmNote">
              <p v-for="(line, index) in MemberCouponMainData.CouponList.Coupon.ConfirmNote.split('\n')" :key="index">
                {{ line }}
              </p>
            </template>
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="cancel_btn" data-dismiss="modal">取消</button> -->
            <button type="button" class="yes_btn" @click="useCoupon()">確定使用</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Paginate from "vuejs-paginate";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);
Vue.component("paginate", Paginate);

// this.$t("立即購買")
const messages = {
  zh_tw: {
  },
  en: {
  },
  jp: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "MemberCouponMain",
  i18n,
  data() {
    return {
      MemberCouponMainData: null,
      local: "zh_tw",
    };
  },
  created: function () {
    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/MemberCouponMain",
      //url: "https://localhost:44321/Html/OrderInfo",
      type: "post",
      data: {
        CPLId: that.$route.params.CPLId,
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得優惠卷過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.MemberCouponMainData = JSON.parse(res.data);
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member_coupon");
    $(".wrapper").addClass("member_coupon_main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  updated: function () { },
  methods: {
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
    useCoupon() {
      $('#couponUseModal').modal('hide');
      let that = this;
      // 顯示請稍候
      that.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/UseCoupon",
        //url: "https://localhost:44321/Html/TicketActive",
        type: "post",
        data: {
          CPLId: that.MemberCouponMainData.CouponList.CPLId,
          token: Storage.get("ek_login_token"),
        },
        dataType: "json",
        error: function () {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("使用優惠卷過程發生錯誤, 請稍後再試一次"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("使用成功"),
              showConfirmButton: false,
              timer: 1500,
              willClose: function () {
                that.$router.push({
                  name: "MemberCoupon",
                  params: {},
                });
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            if (res.toekn_error) {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                willClose: function () {
                  // 移除登入資訊
                  Storage.remove("ek_login_token");
                  // 回到首頁
                  that.$router.push({
                    name: "Home",
                    params: {},
                  });
                },
              });
            } else {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          }
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/MemberCouponMain.vue